import React, { useState } from 'react';
import * as S from './styles';

import SearchIcon from '../../assets/icons/icon-search-black.svg';
import ClearIcon from '../../assets/icons/icon-close-black.svg';

const Search = (props) => {
    return (
        <S.SearchContainer width={props.width}>
            <img src={SearchIcon} alt="Search" />
            <input 
              type="text" 
              placeholder={props.placeholder}
              onChange={props.onChange}
              value={props.value} 
              onBlur={props.onBlur}
              onKeyDown={props.onKeyDown}
            />

            {props.value && (  
              <img src={ClearIcon} alt="Clear" onClick={props.onClear} className='clear-icon' />
            )}
        </S.SearchContainer>
    )
}

export default Search;
